import Phaser from 'phaser';
import { GAME_CONFIG } from '../config';
import {
  getActiveProfile,
  setActiveProfile,
  addGameResult,
} from '../profiles/ProfileManager';

const { width, height } = GAME_CONFIG;

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOverScene' });
  }

  create(data: {
    score: number;
    highScore: number;
    linesCleared: number;
    newRecord: boolean;
    profileId?: string;
  }): void {
    const {
      score,
      highScore,
      linesCleared,
      newRecord,
      profileId,
    } = data;

    // Save result to profile
    const pid = profileId ?? getActiveProfile()?.id;
    if (pid !== undefined) {
      addGameResult(pid, score, linesCleared);
    }

    // Background
    const bg = this.add.graphics();
    bg.fillStyle(0x3e2723, 1);
    bg.fillRect(0, 0, width, height);

    // Decorative
    bg.fillStyle(0x4e342e, 0.3);
    for (let i = 0; i < 30; i++) {
      bg.fillRect(
        Math.random() * width,
        Math.random() * height,
        2 + Math.random() * 4,
        2 + Math.random() * 4,
      );
    }

    // Game Over title
    this.add.text(width / 2, 50, '¡GAME OVER!', {
      fontSize: '36px',
      fontFamily: 'Arial, sans-serif',
      color: '#ff5252',
      fontStyle: 'bold',
    }).setOrigin(0.5, 0);

    if (newRecord) {
      this.add.text(width / 2, 95, '🏆 ¡NUEVO RÉCORD! 🏆', {
        fontSize: '18px',
        fontFamily: 'Arial, sans-serif',
        color: '#ffcc80',
        fontStyle: 'bold',
      }).setOrigin(0.5, 0);
    }

    // Stats panel
    const panelBg = this.add.graphics();
    panelBg.fillStyle(0x4e342e, 1);
    panelBg.fillRoundedRect(width / 2 - 160, 130, 320, 220, 16);
    panelBg.lineStyle(2, 0x8d6e63, 1);
    panelBg.strokeRoundedRect(width / 2 - 160, 130, 320, 220, 16);

    // Stats header
    this.add.text(width / 2, 150, 'Estadísticas de la partida', {
      fontSize: '16px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffcc80',
      fontStyle: 'bold',
    }).setOrigin(0.5, 0);

    // Stat rows
    const stats = [
      { label: 'Puntuación final', value: String(score), color: '#ffffff' },
      { label: 'Mejor puntuación', value: String(highScore), color: '#bcaaa4' },
      { label: 'Líneas limpiadas', value: String(linesCleared), color: '#81c784' },
    ];

    let statY = 180;
    for (const stat of stats) {
      this.add.text(width / 2 - 140, statY, stat.label, {
        fontSize: '15px',
        fontFamily: 'Arial, sans-serif',
        color: '#bcaaa4',
      });

      this.add.text(width / 2 + 140, statY, stat.value, {
        fontSize: '17px',
        fontFamily: 'Arial, sans-serif',
        color: stat.color,
        fontStyle: 'bold',
      }).setOrigin(1, 0);

      statY += 36;
    }

    // Divider
    const divider = this.add.graphics();
    divider.lineStyle(1, 0x8d6e63, 0.5);
    divider.lineBetween(width / 2 - 130, 292, width / 2 + 130, 292);

    // Clean board bonus info
    this.add.text(width / 2, 310, '💡 Tablero limpio = x5 puntos', {
      fontSize: '13px',
      fontFamily: 'Arial, sans-serif',
      color: '#a5d6a7',
    }).setOrigin(0.5, 0);

    // Buttons
    const btnY1 = 380;
    this.createButton(width / 2, btnY1, '🔄 Reintentar', 0x4caf50, () => {
      if (pid !== undefined) {
        setActiveProfile(pid);
        this.scene.start('GameScene', { profileId: pid });
      } else {
        this.scene.start('MenuScene');
      }
    });

    const btnY2 = 440;
    this.createButton(width / 2, btnY2, '🏠 Menú Principal', 0x2196f3, () => {
      this.scene.start('MenuScene');
    });

    // Tip at bottom
    this.add.text(width / 2, height - 30, '¡Los desafíos educativos te dan más intentos!', {
      fontSize: '12px',
      fontFamily: 'Arial, sans-serif',
      color: '#8d6e63',
      fontStyle: 'italic',
    }).setOrigin(0.5);
  }

  private createButton(
    x: number,
    y: number,
    label: string,
    color: number,
    callback: () => void,
  ): void {
    const bg = this.add.graphics();
    bg.fillStyle(color, 1);
    bg.fillRoundedRect(x - 100, y - 20, 200, 44, 10);

    this.add.text(x, y + 2, label, {
      fontSize: '17px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffffff',
      fontStyle: 'bold',
    }).setOrigin(0.5);

    const zone = this.add.zone(x, y, 200, 44).setInteractive({ useHandCursor: true });
    zone.on('pointerdown', callback);
  }
}